import { Fragment } from 'react'
import { Box, styled } from '@mui/material'
import { Attribute, AttributeLabel, AttributeValue } from 'packages/eid-ui'
import { useTranslation } from 'react-i18next'
import { Skeleton } from '@mui/material'
import { MOBILE_SCREEN_WIDTH } from 'packages/core/utils/constants'
import DynamicComponents from 'components/DynamicComponents'
import SubjectTypeAttribute from 'components/SubjectTypeAttribute'

const Content = styled(Box)(({ theme }) => ({
    width: '100%',
    '&.hasAttributes': {
        display: 'flex',
        justifyContent: 'space-between',
        [`@media (max-width:345px)`]: {
            flexDirection: 'column-reverse',
        },
    },
}))

const Section = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    '&.hasAttributes': {
        width: '100%',
        [`@media (max-width:${MOBILE_SCREEN_WIDTH - 1}px)`]: {
            display: 'none',
        },
    },
}))

export const AttributeSections = (props) => {
    const { t } = useTranslation()
    const {
        data,
        attributes,
        labelClassName,
        valueClassName,
        isLoading,
        orientation = 'vertical',
        hideNullValues = false,
    } = props

    const renderComponent = (a, item) => {
        if (a.component.componentName === 'renderer') {
            return <Fragment>{a.component.render(item)}</Fragment>
        } else if (a.component.componentName === 'SubjectType') {
            const subjectType = 'Person' //hardcoded for now as it will always be a person
            return (
                <SubjectTypeAttribute
                    subjectType={subjectType}
                    item={item}
                    personComponentProps={{ ...a.component.props }}
                />
            )
        } else {
            const DynamicComponentToRender =
                DynamicComponents[a.component.componentName]
            return <DynamicComponentToRender attribute={a} data={{ item }} />
        }
    }

    // Filter sections and attributes based on hideNullValues
    const filteredSections = attributes
        .map((section) => {
            // Filter attributes within each section
            return section
                ?.filter((att) => att.display !== false && att.display !== null)
                .filter((att) => {
                    // Filter out attributes with null/empty values if hideNullValues is true
                    if (hideNullValues && !data[att.name]) {
                        return false
                    }
                    return true
                })
        })
        .filter((filteredSection) => {
            // Filter out empty sections (sections with no attributes after filtering)
            return filteredSection && filteredSection.length > 0
        })

    return (
        <>
            {isLoading ? (
                <Box width={'100%'}>
                    <Skeleton height={40} />
                </Box>
            ) : (
                <Content
                    className={
                        filteredSections.length > 1 ? 'hasAttributes' : ''
                    }
                >
                    {filteredSections.map((section, si) => {
                        return (
                            <Section
                                className={
                                    filteredSections.length > 1
                                        ? 'hasAttributes'
                                        : ''
                                }
                                key={`section_${si}`}
                            >
                                {section.map((att, ai) => {
                                    return (
                                        <Attribute
                                            orientation={orientation}
                                            key={`section${si}_attributes_${ai}_${att.label}`}
                                        >
                                            <AttributeLabel
                                                className={labelClassName}
                                            >
                                                {t(att.label)}
                                            </AttributeLabel>
                                            {att.label && (
                                                <AttributeValue
                                                    className={valueClassName}
                                                >
                                                    {data
                                                        ? att.component
                                                            ? renderComponent(
                                                                  att,
                                                                  data,
                                                              )
                                                            : data[att.name]
                                                            ? data[att.name]
                                                            : '-'
                                                        : '-'}
                                                </AttributeValue>
                                            )}
                                        </Attribute>
                                    )
                                })}
                            </Section>
                        )
                    })}
                </Content>
            )}
        </>
    )
}
